export default __webpack_public_path__ + "src/assets/Relevant_yield_logo_topbar.png";